import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=10e79418&lang=scss"

const __exports__ = script;

export default __exports__